const defaultOptions = {
    showOrbitalBar: true,
    showAtomCounter: true,
    showHybridizeButton: true,
};

const currentOptions = { ...defaultOptions };
const authoredOptions = { ...defaultOptions };

export default class Options {

    static getCurrent() {
        return currentOptions;
    }

    static setCurrent(params) {
        const options = Options.parse(params);
        for (let key of Object.keys(options)) {
            currentOptions[key] = options[key];
        }
    }

    static exportAsQueryString(options = currentOptions) {
        const changedOptions = this.getChangedOptions(options).sort();
        if (changedOptions && changedOptions.length > 0) {
            const optionStrings = changedOptions.map(opt => this.getOptionString(opt, options));
            return optionStrings.join("&");
        }
        return "";
    }

    static getOptionString(option, options) {
        return option + "=" + options[option].toString();
    }

    static getChangedOptions(options) {
        const optionNames = Object.keys(defaultOptions);
        const changes = optionNames.filter((opt) => {
            // always include the showOrbitalBar option
            return opt == "showOrbitalBar" || defaultOptions[opt] != options[opt];
        })

        return changes;
    }

    static parseAuthorParams(params) {
        const parsed = {};

        for (let option of params.split(";")) {
            if (option.indexOf("=") > -1) {
                const optionSplit = option.split("=");
                parsed[optionSplit[0]] = optionSplit[1];
            }
        }

        const options = this.parse(parsed);

        this.setAuthoredOptions(options);

        return options;
    }

    static parse(options) {
        return {
            showOrbitalBar: options.showOrbitalBar ? options.showOrbitalBar === "true" : defaultOptions.showOrbitalBar,
            showAtomCounter: options.showAtomCounter ? options.showAtomCounter === "true" : defaultOptions.showAtomCounter,
            showHybridizeButton: options.showHybridizeButton ? options.showHybridizeButton === "true" : defaultOptions.showHybridizeButton,
        };
    }

    static loadGoalOptions(options) {
        const parsed = {};

        for (let option of options.split("&")) {
            if (option.indexOf("=") > -1) {
                const optionSplit = option.split("=");
                parsed[optionSplit[0]] = optionSplit[1];
            }
        }
    }

    static setAuthoredOptions(options) {
        for (let key of Object.keys(options)) {
            authoredOptions[key] = options[key];
        }
    }

    static getAuthoredOptions() {
        return this.exportAsQueryString(authoredOptions);
    }
}
